import { Controller } from 'stimulus';
import { useEventListener } from '@/js/util';

export const EVENT_NAME = 'moodboard--templates--collection-opener:open';

const ACTIVE_PANE_SELECTOR = '.moodboard--tabs--pane.is-active';
const PENDING_PAGE_SELECTOR = 'turbo-frame[src][loading="lazy"]';

export const openCollection = (collectionId) => {
  document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { collectionId } }));
};

export default class extends Controller {
  connect() {
    useEventListener(this);
    this.addEventListener(document, EVENT_NAME, this.#open.bind(this));
  }

  disconnect() {
    this.#stopWaiting();
  }

  preloadImages({ currentTarget }) {
    const source = currentTarget.querySelector('template[data-additional-images]');
    source?.replaceWith(source.content);
  }

  #open({ detail: { collectionId } }) {
    if (this.#openNow(collectionId)) {
      return;
    }

    // Collections load lazily, so a request can arrive before its thumb has rendered.
    this.#waitFor(collectionId);
  }

  #openNow(collectionId) {
    const thumb = document.querySelector(`#board_template_collection_${collectionId}`);
    if (!thumb) {
      return false;
    }

    thumb.querySelector('button').click();
    return true;
  }

  #waitFor(collectionId) {
    this.#stopWaiting();

    this.observer = new MutationObserver(() => {
      if (this.#openNow(collectionId)) {
        this.#stopWaiting();
        return;
      }

      this.#loadPendingPage();
    });
    this.observer.observe(this.element, { childList: true, subtree: true });

    this.#loadPendingPage();
  }

  // Later pages only fetch when scrolled into view, so pull them in until the thumb appears.
  #loadPendingPage() {
    const pane = this.element.querySelector(ACTIVE_PANE_SELECTOR);
    pane?.querySelector(PENDING_PAGE_SELECTOR)?.setAttribute('loading', 'eager');
  }

  #stopWaiting() {
    this.observer?.disconnect();
    this.observer = null;
  }
}
